// extracted by mini-css-extract-plugin
module.exports = {"buttons":"VehicleMoreInformation_buttons__33T4y","required":"VehicleMoreInformation_required__3qRgb"};